import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowUp } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TrendingWidget() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);

  useEffect(() => {
    loadTrending();
    const interval = setInterval(loadTrending, 60000);
    return () => clearInterval(interval);
  }, []);

  function loadTrending() {
    fetch(`${API}/public/trending?window=3h&limit=5`).then(r => r.json()).then(d => setItems(d.trending || [])).catch(() => {});
  }

  if (items.length === 0) return null;

  return (
    <div className="bg-white dark:bg-[#0f172a] rounded-xl p-5 border border-gray-100 dark:border-gray-800" data-testid="trending-widget">
      <h3 className="text-sm font-bold uppercase tracking-wider text-gray-900 dark:text-gray-100 border-l-4 border-red-600 pl-3 mb-4 flex items-center gap-2">
        <span className="relative flex h-2 w-2"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" /><span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" /></span>
        TRENDING SADA
      </h3>
      <div className="space-y-3">
        {items.map((item, i) => (
          <Link to={`/clanak/${item.article.slug}`} key={item.article.id} className="flex gap-3 group" data-testid={`trending-${i}`}>
            <span className="text-2xl font-black text-red-500/90 shrink-0 w-8">{i + 1}</span>
            <div className="min-w-0">
              {item.article.category && (
                <span className="inline-block text-[9px] font-bold uppercase tracking-wider text-white px-1.5 py-0.5 rounded mb-1" style={{ backgroundColor: item.article.category.color || '#3b82f6' }}>
                  {item.article.category.name_hr}
                </span>
              )}
              <h4 className="text-[13px] font-semibold text-gray-800 dark:text-gray-100 group-hover:text-red-600 transition-colors line-clamp-2 leading-snug">{item.article.title_hr}</h4>
              {item.velocity_per_hour > 0 && (
                <span className="text-[10px] text-emerald-600 dark:text-emerald-400 flex items-center gap-0.5 mt-1 font-medium">
                  <ArrowUp size={10} /> {item.velocity_per_hour} pregleda/h
                </span>
              )}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
